/**
 * Created by vladislav on 19.09.2022
 */

const Timer = cleverapps.Layout.extend({
    ctor: function (timeLeft, onFinish, options) {
        options = options || {};

        const styles = cleverapps.styles.Timer;

        const bg = this.bg = new cc.Scale9Sprite(options.timerBg || bundles.timer.frames.timer_bg_png);
        bg.setContentSize2(options.width || styles.width, bg.height);

        const icon = this.icon = new cc.Sprite(options.timerIcon || bundles.timer.frames.timer_png);
        icon.setLocalZOrder(1);
        if (options.iconScale !== undefined) {
            icon.setScale(options.iconScale);
        }

        const countDown = this.countDown = timeLeft < 0 ? timeLeft : new cleverapps.CountDown(timeLeft, {
            onFinish
        });

        const countDownView = this.countDownView = new cleverapps.CountDownView(countDown, {
            font: options.font || cleverapps.styles.FONTS.TIMER_TEXT,
            showHours: options.showHours
        }, {
            onSetTimeDebug: options.onSetTimeDebug,
            timerEndText: options.timerEndText
        });

        countDownView.fitTo(bg.width - 2 * styles.padding.x, bg.height - 2 * styles.padding.y);
        countDownView.setAlignment(options.timerPosition || styles.timer);
        bg.addChild(countDownView);

        this._super([icon, bg], {
            margin: options.margin !== undefined ? options.margin : styles.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    resetTimeLeft: function (timeLeft) {
        this.countDown.resetTimeLeft(timeLeft);
    },

    isOver: function () {
        return this.countDown.getTimeLeft ? this.countDown.getTimeLeft() <= 0 : true;
    },

    fitTo: function (width, height) {
        const styles = cleverapps.styles.Timer;

        if (width === undefined) {
            width = this.width;
        }

        if (height === undefined) {
            height = this.height;
        }

        const scale = Math.min(1, height / this.height);
        this.setScale(scale);

        this.bg.setContentSize2(width / scale - this.icon.width - styles.margin, this.bg.height);
        this.countDownView.fitTo(this.bg.width - 2 * styles.padding.x, this.bg.height - 2 * styles.padding.y);
        this.countDownView.doAlignment();

        this.reshape();
    }
});

cleverapps.styles.Timer = {
    width: 260,
    height: 60,

    margin: -40,

    timer: {
        x: { align: "center", dx: 16 },
        y: { align: "center", dy: 0 }
    },

    padding: {
        x: 36,
        y: 1
    },

    icon: {
        x: { align: "left", dx: -25 },
        y: { align: "center", dy: 3 }
    }
};
